import { render, staticRenderFns } from "./DetalleEvento.vue?vue&type=template&id=4717e25c&scoped=true"
import script from "./DetalleEvento.vue?vue&type=script&lang=js"
export * from "./DetalleEvento.vue?vue&type=script&lang=js"
import style0 from "./DetalleEvento.vue?vue&type=style&index=0&id=4717e25c&prod&scoped=true&lang=css"
import style1 from "./DetalleEvento.vue?vue&type=style&index=1&id=4717e25c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4717e25c",
  null
  
)

export default component.exports